export enum ViewMode {
    preview = 'preview',
    normal = 'normal',
}
